<template>
  <div class="container-fluid">
    <div class="card p-4">
      <div class="card-header pl-3 pr-3">
        <div class="d-flex justify-content-between">
          <div>
            <h5>Coupons</h5>
          </div>
          <div>
            <button
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#add-category"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="tabel-responsive">
          <!--  -->
          <table class="table table-bordered" style="width: 100%">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Code</th>
                <th>Type</th>
                <th>Value</th>
                <th>Starting Date</th>
                <th>Ending date</th>
                <th>Max-Amount</th>
                <th>Orders</th>
                <th>Edit/Delete</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr>
                <td class="text-center" colspan="8">
                  <sweetalert-icon icon="loading" />
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="cou in coupon" :key="cou.id">
                <td>{{ cou.sr }}</td>
                <td>{{ cou.code }}</td>
                <td v-if="cou.type === 0">
                  {{ options[0].text }}
                </td>
                <td v-if="cou.type === 1">
                  {{ options[1].text }}
                </td>
                <td>{{ cou.value }}</td>
                <td>{{ cou.valid_from }}</td>
                <td>{{ cou.valid_end }}</td>
                <td>{{ cou.max_amount }}</td>
                <!-- Orders -->
                <td>
                  <a :href="getorderaddress(cou.id)"
                    ><b-button type="submit" variant="outline-primary"
                      >Orders</b-button
                    ></a
                  >
                </td>
                <td>
                  <button
                    class="btn btn-warning btn-sm"
                    data-toggle="modal"
                    data-target="#edit-coupon"
                    @click="
                      setEditableData(
                        cou.code,
                        cou.max_amount,
                        cou.status,
                        cou.valid_end,
                        cou.valid_from,
                        cou.value,
                        cou.id
                      )
                    "
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                  &nbsp;&nbsp;
                  <b-button
                    v-b-modal.todelete
                    class="ml-1 btn btn-danger btn-sm"
                    @click="savedeletecouponid(cou.id)"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
            <!--  -->
          </table>
        </div>
      </div>
    </div>
    <!-- DELETE MODAL -->
    <div>
      <b-modal v-if="!deleted" id="todelete" title="Delete Coupon" hide-footer>
        <p class="my-4">Are you sure to want to delete this Coupon?</p>
        <b-button class="mt-3 btn-danger" block @click="deletecoupon()"
          >Delete</b-button
        >
      </b-modal>
    </div>

    <!-- edit modal start -->
    <div
      class="modal fade"
      role="dialog"
      tabindex="-1"
      id="edit-coupon"
      ref="edit-cat"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header" v-if="!savedChanges">
            <h5 class="modal-title">Edit Coupon</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="savedChanges = false"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body " v-if="savedChanges">
            <b-button block class="btn-success">Successfully Updated</b-button>
            <b-button @click="savedChanges = false" class="mt-3 btn-dark" block
              >Close</b-button
            >
          </div>
          <div class="modal-body" v-if="!savedChanges">
            <form v-on:submit.prevent="editSubmitHandler">
              <div class="form-group">
                <label for="">Code</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Code"
                  v-model="editCoupon.code"
                />
              </div>
              <div class="form-group">
                <label for="">Max Amount</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="editCoupon.max_amount"
                />
              </div>
              <div class="form-group row">
                <!-- Status -->
                <div class="col-sm-6">
                  <label for="">Status</label><br />
                  <label class="radio-inline mr-4">
                    <input
                      type="radio"
                      name="statusradio"
                      v-model="editCoupon.status"
                      value="true"
                      checked
                      required
                    />
                    True
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="statusradio"
                      v-model="editCoupon.status"
                      value="false"
                      required
                    />
                    False
                  </label>
                </div>
                <!-- Type -->
                <div class="col-sm-6">
                  <label for="">Type</label><br />
                  <div>
                    <b-form-select
                      v-model="editCoupon.type"
                      :options="options"
                    ></b-form-select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="">Valid From</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="editCoupon.valid_from"
                />
              </div>
              <div class="form-group">
                <label for="">Valid Till</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="editCoupon.valid_end"
                  @click="seteditlimit"
                  :min="editlimit"
                />
              </div>
              <div class="form-group">
                <label for="">Value</label>
                <input
                  type="Number"
                  class="form-control"
                  placeholder="Value"
                  v-model="editCoupon.value"
                />
              </div>
              <div class="form-group">
                <button
                  class="btn btn-primary btn-block"
                  disabled
                  v-if="editLoading"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </button>
                <button type="submit" class="btn btn-primary btn-block" v-else>
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- edit modal end -->

    <!-- add modal start -->
    <div
      class="modal"
      role="dialog"
      tabindex="-1"
      id="add-category"
      ref="create-cat"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Create Coupon</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="addednew = false"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form v-on:submit.prevent="createCouponSubmitHandler">
              <div class="form-group">
                <label for="">Code</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Code"
                  v-model="newCoupon.code"
                  required
                />
              </div>
              <div class="form-group">
                <label for="">Max Amount</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="newCoupon.max_amount"
                  required
                />
              </div>
              <div class="form-group row">
                <!-- Status -->
                <div class="col-sm-6">
                  <label for="">Status</label><br />
                  <label class="radio-inline mr-4">
                    <input
                      type="radio"
                      name="statusradio"
                      v-model="newCoupon.status"
                      value="true"
                      checked
                      required
                    />
                    True
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="statusradio"
                      v-model="newCoupon.status"
                      value="false"
                      required
                    />
                    False
                  </label>
                </div>
                <!-- Type -->
                <div class="col-sm-6">
                  <label for="">Type</label><br />
                  <div>
                    <b-form-select
                      v-model="newCoupon.type"
                      :options="options"
                    ></b-form-select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="">Valid From</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="newCoupon.valid_from"
                  @click="setlimitfrom"
                  :min="validfrom"
                  required
                />
              </div>
              <div class="form-group">
                <label for="">Valid Till</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="newCoupon.valid_end"
                  @click="setlimittill"
                  :min="validfromtill"
                  required
                />
              </div>
              <div class="form-group">
                <label for="">Value</label>
                <input
                  type="Number"
                  class="form-control"
                  placeholder="Value"
                  v-model="newCoupon.value"
                  required
                />
              </div>
              <div class="form-group">
                <button class="btn btn-success btn-block" v-if="createLoading">
                  Successfully Created
                </button>
                <button type="submit" class="btn btn-primary btn-block" v-else>
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- add modal end -->
  </div>
</template>

<script>
import { dbFs } from "../../modules/database";

export default {
  data() {
    return {
      validfrom: null,
      validfromtill: null,
      editlimit: null,
      savedChanges: false,
      addednew: false,
      deleted: false,
      couponid: "",
      coupon: null,
      loading: false,
      createLoading: false,
      editLoading: false,
      category: null,
      newCoupon: {
        code: "",
        max_amount: 0,
        status: true,
        type: 0,
        valid_end: "",
        valid_from: "",
        value: 0
      },
      editCoupon: {
        code: "",
        max_amount: 0,
        status: true,
        type: 0,
        valid_end: "",
        valid_from: "",
        value: 0
      },
      monthconvertor: {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12"
      },
      options: [{ value: 0, text: "Coupon" }, { value: 1, text: "CashBack" }]
    };
  },
  mounted() {
    this.getCoupon();
  },
  methods: {
    getorderaddress(id) {
      return "/coupons/" + id;
    },
    getCoupon() {
      this.loading = true;
      this.$bind("coupon", dbFs.collection("coupon"))
        .then(() => {
          this.loading = false;
          var ind = 1;
          this.coupon.forEach(doc => {
            // var validf = parseInt(doc.valid_from, 10);
            var y = new Date(doc.valid_from);
            var x = y.toString().split(" ");
            for (const [key, value] of Object.entries(this.monthconvertor)) {
              if (x[1] === `${key}`) {
                x[1] = `${value}`;
              }
            }
            var from = x[3] + "-" + x[1] + "-" + x[2];
            doc.valid_from = from;

            // var validt = parseInt(doc.valid_end, 10);
            var a = new Date(doc.valid_end);
            var b = a.toString().split(" ");
            for (const [key, value] of Object.entries(this.monthconvertor)) {
              if (b[1] === `${key}`) {
                b[1] = `${value}`;
              }
            }
            var till = b[3] + "-" + b[1] + "-" + b[2];
            doc.valid_end = till;

            // Serial Number
            doc["sr"] = ind.toString() + ".";
            ind++;
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    setlimitfrom() {
      this.validfrom = new Date();
      var x = this.validfrom.toString().split(" ");
      for (const [key, value] of Object.entries(this.monthconvertor)) {
        if (x[1] === `${key}`) {
          x[1] = `${value}`;
        }
      }
      var y = x[3] + "-" + x[1] + "-" + x[2];
      this.validfrom = y;
      this.validfromtill = y;
    },
    setlimittill() {
      this.validfromtill = this.newCoupon.valid_from;
    },
    seteditlimit() {
      this.editlimit = this.editCoupon.valid_from;
    },

    createCouponSubmitHandler() {
      var x = this.newCoupon.valid_from.split("-");
      for (const [key, value] of Object.entries(this.monthconvertor)) {
        if (x[1] === `${value}`) {
          x[1] = `${key}`;
        }
      }
      var y = x[1] + " " + x[2] + ", " + x[0];
      const datefrom = new Date(y);
      const timestampfrom = datefrom.getTime();
      this.newCoupon.valid_from = timestampfrom;

      var z = this.newCoupon.valid_end.split("-");
      for (const [key, value] of Object.entries(this.monthconvertor)) {
        if (z[1] === `${value}`) {
          z[1] = `${key}`;
        }
      }
      var p = z[1] + " " + z[2] + ", " + z[0];

      const datetill = new Date(p);
      const timestamptill = datetill.getTime();
      this.newCoupon.valid_end = timestamptill;

      this.createLoading = true;
      dbFs
        .collection("coupon")
        .doc()
        .set(this.newCoupon)
        .then(() => {
          // this.newCoupon.code = ""
          // this.newCoupon.max_amount= 0
          // this.newCoupon.status = true
          // this.newCoupon.valid_end = ""
          // this.newCoupon.valid_from = ""
          // this.newCoupon.value = 0
          this.addednew = true;
          window.location.reload();
        })
        .catch(() => {
          console.log("ERROR AA GYA");
          this.createLoading = false;
        });
      return;
    },
    setEditableData(
      code,
      max_amount,
      status,
      valid_end,
      valid_from,
      value,
      id
    ) {
      this.editCoupon.code = code;
      this.editCoupon.max_amount = max_amount;
      this.editCoupon.status = status;
      this.editCoupon.valid_end = valid_end;
      this.editCoupon.valid_from = valid_from;
      this.editCoupon.value = value;
      this.couponid = id;
    },
    editSubmitHandler() {
      this.editLoading = true;
      var x = this.editCoupon.valid_from.split("-");
      for (const [key, value] of Object.entries(this.monthconvertor)) {
        if (x[1] === `${value}`) {
          x[1] = `${key}`;
        }
      }
      var y = x[1] + " " + x[2] + ", " + x[0];
      const datefrom = new Date(y);
      const timestampfrom = datefrom.getTime();
      this.editCoupon.valid_from = timestampfrom;

      var z = this.editCoupon.valid_end.split("-");
      for (const [key, value] of Object.entries(this.monthconvertor)) {
        if (z[1] === `${value}`) {
          z[1] = `${key}`;
        }
      }
      var p = z[1] + " " + z[2] + ", " + z[0];

      const datetill = new Date(p);
      const timestamptill = datetill.getTime();
      this.editCoupon.valid_end = timestamptill;
      dbFs
        .collection("coupon")
        .doc(this.couponid)
        .set(this.editCoupon)
        .then(() => {
          this.editLoading = false;
          this.savedChanges = true;
        })
        .catch(() => {
          console.log("ERROR AA GYA");
          this.editLoading = false;
        });
    },
    savedeletecouponid(id) {
      this.couponid = id;
    },
    deletecoupon() {
      this.loading = true;
      dbFs
        .collection("coupon")
        .doc(this.couponid)
        .delete()
        .then(() => {
          this.loading = false;
          this.deleted = true;
          this.couponid = "";
        })
        .catch(() => console.log("Some error occured"));
      setTimeout(() => {
        this.deleted = false;
      }, 2000);
    }
  }
};
</script>

<style></style>
